<template>
  <b-card title="مدیریت اطلاع رسانی">
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  variant="primary"
                  class="mb-1 mr-auto ml-1"
                  :to="{ name: 'editAnnouncement'}"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="وضعیت"
                    label-for="Status"
                >
                  <v-select
                      v-model="filterOptions.Status"
                      dir="rtl"
                      :reduce="x => x.value"
                      label="text"
                      :clearable="true"
                      :options="enums('notificationStatus')"
                  />
                </b-form-group>
              </b-col>
<!--              <b-col md="2">-->
<!--                <b-form-group-->
<!--                    label="نوع"-->
<!--                    label-for="Type"-->
<!--                >-->
<!--                  <v-select-->
<!--                      v-model="filterOptions.Type"-->
<!--                      dir="rtl"-->
<!--                      :reduce="x => x.value"-->
<!--                      label="text"-->
<!--                      :clearable="true"-->
<!--                      :options="enums('sendVia')"-->
<!--                  />-->
<!--                </b-form-group>-->
<!--              </b-col>-->
              <b-col md="2">
                <b-form-group
                    label="از تاریخ"
                    label-for="StartDate"
                >
                  <date-picker
                      v-model="filterOptions.FromDate"
                      clearable
                      type="date"
                      format="YYYY-MM-DD"
                      display-format="jYYYY-jMM-jD"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="تا تاریخ"
                    label-for="StartDate"
                >
                  <date-picker
                      v-model="filterOptions.ToDate"
                      clearable
                      type="date"
                      format="YYYY-MM-DD"
                      display-format="jYYYY-jMM-jD"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="warning"
                  @click="update(1)"
                  class="mb-1 mr-1"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
            :no-local-sorting="true"
        >
          <template #cell(SendTime)="data">
            {{ data.value | date }}
          </template>

          <template #cell(IsDraft)="data">
            {{
              data.item.IsDone === true ?
                  "ارسال شده" :
                  data.value ?
                      'پیش نویس'
                      :
                      'در اننتظار ارسال'
            }}
          </template>
          <template #cell(Type)="data">
            {{ enums('sendVia','value',data.value,'text') }}
          </template>

          <template #cell(Id)="data">
            <b-link
                :to="{ name: 'sendNotification', params: { messageId: data.item.Id }}"
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Repeat)="data">
            <b-avatar :variant="data.value?'light-info':'light-warning'">
              <feather-icon
                  v-b-tooltip.hover.top="data.value?' تکرار فعال ':'تکرار غیرفعال'"
                  icon="RepeatIcon"
                  class="cursor-pointer"
                  @click="showRepeatModal(data.item)"
              />
            </b-avatar>
          </template>

          <template #cell(IsDone)="data">
            <b-avatar :variant="data.value?'light-info':'light-warning'">
              <feather-icon
                  v-b-tooltip.hover.top="data.value?'ارسال شده':'در انتظار'"
                  icon="RepeatIcon"
                  class="cursor-pointer"
              />
            </b-avatar>
          </template>
          <template #cell(Description)="data">
            <template v-for="(item, index) in data.value.split('\n')">
              <br v-if="index > 0 && item.trim()">
              {{item}}
            </template>
          </template>

          <template #cell(actions)="data">
            <div class="text-nowrap">
              <b-link :to="{ name: 'editAnnouncement', params: { id: data.item.Id }}">
                <feather-icon
                    icon="EditIcon"
                    size="16"
                    class="ml-1"
                />
              </b-link>
              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>
          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>
    <b-modal
        v-model="showRemoveModal"
        title="حذف"
        size="sm"
        centered
        hide-footer
        modal-class="modal-danger"
        :no-close-on-backdrop="true"
    >
      <b-overlay
          :show="loadingRemove"
          rounded="sm"
      >
        <span>آیا مطمئن هستید که می خواهید این مورد را حذف کنید؟</span>
        <b-col class="mt-3 text-center">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="danger"
              class="mr-1"
              @click="confirmRemove"
          >
            تایید
          </b-button>
          <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="showRemoveModal = false"
          >
            انصراف
          </b-button>
        </b-col>
      </b-overlay>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: 'listDeclaration',
  data() {
    return {
      totalRows: 1000 * 1000,
      filterOptions: {
        Page: 1,
        Title: null,
        PerPage: 10,
        Type: null,
        IsDraft: null,
        IsDone: null,
        Repeat: null,
        FromDate: this.$moment().startOf('jMonth').format('YYYY/MM/DD'),
        ToDate: this.$moment().endOf('jMonth').format('YYYY/MM/DD'),
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Description',
          label: 'متن',
        },
        {
          key: 'SendTime',
          label: 'تاریخ ارسال',
        },
        {
          key: 'IsDraft',
          label: 'پیشفرض',
        },
        {
          key: 'Repeat',
          label: 'تکرار',
        },
        // {
        //   key: 'Duplicate',
        //   label: 'تکراری',
        // },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      loading: false,
      id: null,
      userId: null,
      isShow: false,
      repeatModal: false,
      row: null,
      statusModal: false,
      loadingExamine: false,
      loadingRemove: false,
      showRemoveModal: false,
      showReportModal: false,
      showPush: true,
      processing: false,
      counter: 1
    }
  },
  watch: {
    showPush(val) {
      if (!val) this.userId = null
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })
      if (this.filterOptions.Status === 'draft') {
        this.filterOptions.IsDone = null
        this.filterOptions.IsDraft = true
      } else if (this.filterOptions.Status === 'waitToSent') {
        this.filterOptions.IsDone = false
        this.filterOptions.IsDraft = false
      } else if (this.filterOptions.Status === null) {
        this.filterOptions.IsDone = null
        this.filterOptions.IsDraft = null
      } else if (this.filterOptions.Status === 'done') {
        this.filterOptions.IsDone = true
        this.filterOptions.IsDraft = null
      }
      this.$http.post(
          this.$api.announcement.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
            this.loading = false
          })
          .finally(() => {
            this.loading = false
          })
    },
    remove(id) {
      this.id = id
      this.showRemoveModal = true
    },
    confirmRemove() {
      this.loadingRemove = true
      this.$http.post(
          this.$api.announcement.remove, { Id: this.id },
      )
          .then(() => {
            this.showRemoveModal = false
            this.loadingRemove = false
            this.update()
          }).catch(() => {
        this.loadingRemove = false
        this.showRemoveModal = false
      })
    },
    showModal(id){
      this.userId = null
      this.id = id
      this.isShow = true
    },
    showRepeatModal(row){
      this.row = JSON.parse(JSON.stringify(row))
      this.repeatModal = true
    },
    save(){
      this.$http.post(
          this.$api.declarations.recurring, this.row,
      )
          .then(res => {
            this.update()
            this.repeatModal = false
          })
    },
    showReport(row) {
      this.row = row
      this.showReportModal = true
    },
  }
}
</script>

<style scoped>
.notification-status{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.item-status-title {
  margin-bottom: 0px;
  color: #6e6b7b;
}
.font-weight-700{
  font-weight: 600;
  color: #5e5873;
}
</style>
